/** Gradiente base — mesmo do login (também usado na sidebar) */
export const authSurfaceGradientClass =
  "bg-gradient-to-br from-zinc-950 via-[#0a2420] to-apcap-deep";

/** Brilho esmeralda suave (login + sidebar) */
export const authSurfaceGlowOverlayClass =
  "pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(16,185,129,0.12),transparent)]";

/** Vinheta clara/escura (login + sidebar) */
export const authSurfaceVignetteOverlayClass =
  "pointer-events-none absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.04)_0%,transparent_40%,rgba(0,0,0,0.18)_100%)]";

/** Fundo da página de autenticação */
export const authPageBgClass =
  "relative min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-zinc-950 via-[#0a2420] to-apcap-deep";

/**
 * Cartão do formulário — fundo branco sólido para contraste forte com o fundo escuro da página.
 */
export const authCardClass =
  "rounded-2xl border border-zinc-200 bg-white p-6 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.35),0_0_0_1px_rgba(0,0,0,0.04)] ring-1 ring-white sm:p-8";

/** Links de apoio (login, voltar, cadastro) */
export const authLinkClass =
  "font-semibold text-apcap underline-offset-4 decoration-apcap/25 transition-colors hover:text-apcap-light hover:decoration-apcap";

export const authIconClass = "text-apcap shrink-0";

/** Divisor “ou” entre ações */
export const authDividerLineClass = "border-t border-zinc-200";

export const authMutedTextClass = "text-sm text-zinc-500";

/** Título — sempre legível sobre o cartão branco */
export const authTitleClass =
  "text-2xl font-semibold tracking-tight text-zinc-900 sm:text-[1.65rem]";

export const authSubtitleClass =
  "mt-2 text-sm leading-relaxed text-zinc-600";
